export default __webpack_public_path__ + "static/LpRpo01PageRewards-d1bd3451a8f55a2e7dfbe4ba93ff50f9.png";